<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="this.$parent.optionsStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="4" class="p-a-0 m-t-5px">
                        <multiselect v-model="pessoa"
                        :options-limit="300"
                        :limit="2"
                        :limit-text="limitText"
                        :options="optionsClientes"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Cliente ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingTom"
                        @search-change="listaClientes"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="4" class="p-a-0 m-t-5px">
                        <multiselect v-model="unidade"
                        :options-limit="300"
                        :limit="2"
                        :limit-text="limitText"
                        :options="optionsUnidades"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Unidade ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingTom2"
                        @search-change="listaUnidades"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  props: {
    tabela: '',
  },
  data () {
    return {
      pessoa: '',
      unidade: '',
      isLoadingTom: false,
      isLoadingTom2: false,
      helpForm: new Form({params: [], search: ''}),
      cd: '',
      descr: '',
      optionsClientes: [],
      optionsUnidades: [],
      optionsLivStatus: [],
      status: [],
      data_filter: []
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {pessoa: this.pessoa,
                              unidade: this.unidade,
                              status: this.status}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.pessoa = '';  // clear the text in text input
        this.unidade = '';
        this.status = '';
        this.$events.fire('filter-reset');
      },
        listaClientes(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsClientes = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsClientes.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
        listaUnidades(search) {
            if(search.length>=3)
            {
                // this.isLoadingTom2 = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/unidade/jsonlist').then(response =>
                {
                    this.optionsUnidades = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsUnidades.push({ label: obj.cd+" - "+obj.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(obj.pessoa.pessoa_juridica.cnpj_base,obj.pessoa.pessoa_juridica.cnpj_filial,obj.pessoa.pessoa_juridica.cnpj_digito)+" - "+obj.pessoa.pessoa_juridica.inscricao_estadual, value: obj.unidade_id })
                    });
                    // this.isLoadingTom2 = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
